import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { LayoutDashboard } from '../layouts/layout-dashboard';
import { useAxios } from './../hooks/useAxios';

const IntelligentComponent = () => {
  const [searchResults, setsearchResults] = useState(null);
  const searchField = useRef();
  const { data, error, loading, fetchNow } = useAxios();
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (loading) return;

    if (isFetching && data?.results) {
      setsearchResults(data?.results);
      setIsFetching(false);
    }
  }, [data, loading, isFetching]);

  if (error) {
    console.log('error', error);
    return null;
  }

  const extractData = async () => {
    setIsFetching(true);
    fetchNow(`/api/nlp-document-store/query`, 'POST', { query: searchField.current.value }, false);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg={12} className="p-5">
            <div className="wrapper">
              <LayoutDashboard>
                <Row>
                  <Col>
                    <>
                      <h2>Search Document</h2>
                      <form>
                        <input type="text" ref={searchField} />
                        <Button onClick={extractData}>Search</Button>
                      </form>
                    </>
                  </Col>
                </Row>
                {searchResults ? (
                  <Row>
                    <Col>
                      <h2>Search Result</h2>
                      <ul>
                        {searchResults.map((result, key) => (
                          <li key={key}>
                            <h4>{result.document}</h4>
                            <p>{result.documentText}</p>
                            <a href={`${result.documentUri}`} target="_blank" rel="noopener">
                              Download Document
                            </a>
                          </li>
                        ))}
                      </ul>
                    </Col>
                  </Row>
                ) : null}
              </LayoutDashboard>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { IntelligentComponent };
